// Hooks
import useApi from "./useApi"

// Utils & misc
import { API_STAGES_URL } from "../../constants/constants"

const useMotivesApi = () => {
  const [requestState, payload, error, request] = useApi()

  const getMotives = () => request("GET", `${API_STAGES_URL}/v1/motives`)

  return [
    requestState,
    payload,
    error,
    {
      getMotives,
    },
  ]
}

export default useMotivesApi
